import { ChatBotDataList } from '@/Workspaces/ChatBotData/ChatBotDataList'
import { ChatBotDataPage } from '@/Workspaces/ChatBotData/ChatBotDataPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/workspace/$workspaceId/chatBotData/$chatBotDataId/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <ChatBotDataPage />
}
